import React, { useState, useEffect } from 'react';
import { wishlistService } from '../services/wishlist';

const ProductCard = ({ product, onAddToCart, onViewDetails }) => {
  const [isInWishlist, setIsInWishlist] = useState(false);

  useEffect(() => {
    setIsInWishlist(wishlistService.isInWishlist(product.productId));
  }, [product.productId]);

  const toggleWishlist = (e) => {
    e.stopPropagation();
    if (isInWishlist) {
      wishlistService.removeFromWishlist(product.productId);
      setIsInWishlist(false);
    } else {
      wishlistService.addToWishlist({
        id: product.productId,
        name: product.name,
        price: pricing.price,
        image_url: product.imageUrl,
        slug: product.slug || product.productId
      });
      setIsInWishlist(true);
    }
  };

  const pricing = product.platforms
    ? product.platforms.android
    : { price: product.price };

  const hasDiscount = product.discount_price && product.discount_price > pricing.price;
  const discountPercent = hasDiscount
    ? Math.round(((product.discount_price - pricing.price) / product.discount_price) * 100)
    : 0;

  return (
    <div className="product-card" onClick={onViewDetails}>
      {hasDiscount && <span className="discount-badge">-{discountPercent}%</span>}

      {/* Wishlist btn */}
      <button
        onClick={toggleWishlist}
        style={{
          position: 'absolute',
          top: '10px', left: '10px',
          background: 'rgba(0,0,0,0.5)',
          backdropFilter: 'blur(6px)',
          border: '1px solid rgba(255,255,255,0.15)',
          borderRadius: '50%',
          padding: 0,
          width: '32px', height: '32px',
          cursor: 'pointer',
          zIndex: 10,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          transition: 'transform 0.2s, background 0.2s'
        }}
        onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.15)'}
        onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
        aria-label={isInWishlist ? 'Remove from wishlist' : 'Add to wishlist'}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
          fill={isInWishlist ? '#ef4444' : 'none'}
          stroke={isInWishlist ? '#ef4444' : 'rgba(255,255,255,0.7)'}
          strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
        </svg>
      </button>

      {/* Product image */}
      <div className="product-img-wrap" style={{ width: '100%', borderRadius: '16px', overflow: 'hidden', background: 'linear-gradient(135deg,#1a1a2e,#16213e)', minHeight: '140px', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
        {product.imageUrl ? (
          <img
            src={product.imageUrl}
            alt={product.name}
            style={{ width: '100%', aspectRatio: '1', objectFit: 'cover', display: 'block', borderRadius: '16px' }}
            onError={e => { e.target.style.display = 'none'; }}
          />
        ) : (
          <span style={{ fontSize: '3rem' }}>👾</span>
        )}
      </div>

      {/* Name */}
      <h3>{product.name}</h3>

      {/* Footer: buy + price */}
      <div className="product-card-footer">
        <button className="buy-btn" type="button">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/></svg>
          Buy
        </button>
        <div style={{ textAlign: 'right', flexShrink: 0 }}>
          {hasDiscount && <span className="original-price">${product.discount_price}</span>}
          <span className="price">${pricing.price}</span>
        </div>
      </div>

    </div>
  );
};

export default ProductCard;
